





























import { confirmDelete } from '@/libs/decorator';
import BasePageMixin from '@/mixins/base-page-mixin';
import CategoryServices, { CategoryDto } from '@/services/category';
import RuleSetServices, { RuleSetDto } from '@/services/ruleSet';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import RuleSets from './rule-sets.vue';

@Component({
  components: { RuleSets }
})
export default class Left extends mixins(BasePageMixin) {
  categorySrv = new CategoryServices();
  ruleSrv = new RuleSetServices();
  visible: boolean = false;
  categoryType: number = 6;
  folderId: any = 0;
  modalVisible: boolean = false;
  ruleSetId: number = 0;

  menu: any = [];
  async created() {
    this.getCategory(this.categoryType);
  }

  // 获取目录
  async getCategory(categoryType: number) {
    let list = await this.categorySrv.getList({ categoryType_eq: categoryType });
    this.menu = list.map((cate: CategoryDto) => ({
      title: cate.categoryName,
      icon: cate.icon,
      type: 'folder',
      record: cate,
      oprate: [
        { name: '新建决策集', icon: 'fa-plus-circle', permissionKey: 'RULE_SET_ADD', key: `add` },
        { name: '编辑目录', icon: 'fa-edit', key: `editFolder` },
        { name: '删除目录', icon: 'fa-trash', key: `removeFolder` }
      ],
      expand: false,
      id: cate.id,
      children: []
    }));
  }

  // 获取目录下文件
  async openFolderById(id: number) {
    let index = this.menu.findIndex((v: any) => v.id == id);
    this.menu[index].loading = true;
    let list = await this.ruleSrv.getList({ ruleSetCategoryId_eq: id });
    let plist: object[] = [];
    list.forEach((rule: RuleSetDto) => {
      plist.push({
        title: rule.ruleSetName,
        key: `/decision/rule?ruleSetId=${rule.id}&ruleSetCode=${rule.ruleSetCode}`,
        icon: 'fa-cube',
        id: rule.id,
        record: rule,
        oprate: [
          { name: '编辑', permissionKey: 'RULE_SET_UPD', icon: 'fa-edit', key: 'edit' },
          { name: '删除', permissionKey: 'RULE_SET_DEL', icon: 'fa-trash', key: 'remove' }
        ]
      });
    });
    this.menu[index].children = plist;
    this.menu[index].expand = true;
    this.menu[index].loading = false;
  }

  command(key: string, record: any) {
    switch (key) {
      case 'add': // 新建
        this.ruleSetId = 0;
        this.folderId = record.id;
        this.modalVisible = true;
        break;
      case 'edit': // 编辑
        this.ruleSetId = record.id;
        this.modalVisible = true;
        break;
      case 'remove': // 删除
        this.removeRuleSet(record.id);
        break;
      case 'addFolder': // 新建目录
        this.folderId = 0;
        this.visible = true;
        break;
      case 'editFolder': // 编辑目录
        this.folderId = record.id;
        this.visible = true;
        break;
      case 'removeFolder': // 删除目录
        this.removeFolder(record.id);
        break;
      case 'expandFolder': // 展开目录
        this.openFolderById(record.id);
        break;
      case 'link':
        this.$router.push(record);
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  async removeFolder(id: number) {
    let res = await this.categorySrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  @confirmDelete()
  async removeRuleSet(id: string) {
    let res = await this.ruleSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  reloadMenu() {
    // 重新载入目录下文件
    let openFolderIds: number[] = [];
    this.menu.forEach((v: any, index: number) => {
      if (v.expand) {
        openFolderIds.push(v.id);
      }
    });
    this.getCategory(this.categoryType);
    openFolderIds.forEach(id => this.openFolderById(id));
  }
}
